"use client"

import { useState } from "react"
import { useMediaQuery, Badge, Avatar } from "@mui/material"
import { MobileNav } from "./mobile-nav"
import { Sidebar } from "./sidebar"
import { TransactionCard } from "./transaction-card"
import { ArrowDownLeft, ArrowUpRight, RefreshCw, CreditCard, Bell, LogOut, Key, Menu, Sparkles, Search } from "lucide-react"
import { capitalizeFirstLetter, guessAdminRoute } from "../../../../utility/Helper1"
import { allRemoteSettingsSelect, userSelect } from "../../../../redux/selectors"
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom"
import { authActions } from "../../../../redux/actions"


export default function WrapUpP2p({ children }) {
  const [activeTab, setActiveTab] = useState()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const isMobile = useMediaQuery("(max-width: 768px)")
  const site_settings = useSelector(allRemoteSettingsSelect);
  const userData = useSelector(userSelect);
  const navigate = useNavigate()
  const dispatch = useDispatch();



  const doLogOutNowNow = () => {
    dispatch(authActions.onLogout());
  };
  return (
    <div className="flex h-screen w-full overflow-hidden bg-gradient-to-br from-gray-950 to-black text-white">
      {!isMobile && (
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} open={sidebarOpen} setOpen={setSidebarOpen} />
      )}

      <div className="flex flex-1 flex-col overflow-hidden">

        <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-purple-500/20 bg-gradient-to-r from-gray-900 to-black px-4 shadow-md md:px-6">
          <div className="flex items-center">

            {!isMobile && <button
              onClick={() => setSidebarOpen((prev) => !prev)}
              className="mr-4 rounded-lg p-2 text-gray-400 hover:bg-white/5 hover:text-purple-300 md:hidden"
            >
              <Menu className="h-6 w-6" />
            </button>}

            <h1 onClick={() => navigate('/')} className="pointer text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-400 md:hidden">
              {capitalizeFirstLetter(site_settings?.site_settings?.sitename)}
            </h1>
          </div>


          <div className="flex items-center space-x-2">
            <button onClick={doLogOutNowNow} className="relative rounded-full p-2 text-gray-400 hover:bg-white/5 hover:text-purple-300">
              <LogOut className="h-6 w-6" />
            </button>

            <button onClick={() => navigate('/update/security')} className="relative rounded-full p-2 text-gray-400 hover:bg-white/5 hover:text-purple-300">
              <Key className="h-6 w-6" />
            </button>


            <Avatar
              className="pointer"
              onClick={() => navigate('/mine')}
              sx={{
                width: 40,
                height: 40,
              }}
              src={`${guessAdminRoute()}/${userData?.image}`}
            />

          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 mb-16 md:p-6 md:pb-0" stsyle={{marginBottom: 50}}>
          <div className="space-y-6">
            {children}
          </div>
        </main>

        {isMobile && <MobileNav activeTab={activeTab} setActiveTab={setActiveTab} />}
      </div>
    </div>
  )
}
